import { render, staticRenderFns } from "./OnGoingOrders.vue?vue&type=template&id=6a41e860&scoped=true&"
import script from "./OnGoingOrders.vue?vue&type=script&lang=js&"
export * from "./OnGoingOrders.vue?vue&type=script&lang=js&"
import style0 from "./OnGoingOrders.vue?vue&type=style&index=0&id=6a41e860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a41e860",
  null
  
)

export default component.exports